import React from 'react'
import { CalendarIcon } from 'ui/schedule'
import { ReadOnlyModel } from '@morningtrain/react-resources'
import { Can } from '@morningtrain/react-auth'

export default function ScheduleNotifications ({
  date = null,
  scheduleId
}) {
  return (
    <Can permission='api.shifts.special_days.index'>
      <ReadOnlyModel resourceName='shifts.schedule' operationName='fetch'>
        <CalendarIcon date={date} scheduleId={scheduleId} />
      </ReadOnlyModel>
    </Can>
  )
}
